import { CurrentUser } from "../Helpers/CurrentUser";
import api from "./api";

export const getMunicipalities = async () => {
	return api
		.get(process.env.REACT_APP_SERVER_URL + "/Municipalities", {data: {"authorization":CurrentUser.getToken()}})
		.then((response) => {
			return response.data;
		});
}